module.exports = __webpack_public_path__ + "static/media/demo-1-min.b5274a89.webp";